export var getI18nextRequestEndpoint = function (_a) {
    var locale = _a.locale, namespace = _a.namespace;
    return "/I18N/" + namespace + "/" + locale + "/i18next";
};
